// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"612":"771c4b6d653d11a0","8364":"7f318ed732a2b629"}[chunkId] + ".css";
};